import React from "react";
import Transaction from "./Transaction";
import counterpart from "counterpart";
import Translate from "react-translate-component";
import TransactionConfirmActions from "actions/TransactionConfirmActions";
import TransactionConfirmStore from "stores/TransactionConfirmStore";
import { connect } from "alt-react";
import Icon from "../Icon/Icon";
import WalletDb from "stores/WalletDb";
import AccountStore from "stores/AccountStore";
import AccountSelect from "components/Forms/AccountSelect";
import { ChainStore } from "bitsharesjs";
import utils from "common/utils";
import Operation from "components/Blockchain/Operation";
import notify from "actions/NotificationActions";
import { Modal, Button, Icon as AIcon, Alert, Switch, Input } from "bitshares-ui-style-guide";
import QRCode from "qrcode.react";

class TransactionConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      isErrorDetailsVisible: false,
      showQrCode: false
    };
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onConfirmClick = this.onConfirmClick.bind(this);
    this.onShowDetailsClick = this.onShowDetailsClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.transaction) {
      return false;
    }

    if (nextState.isErrorDetailsVisible !== this.state.isErrorDetailsVisible || nextState.showQrCode !== this.state.showQrCode) {
      return true;
    }

    return !utils.are_equal_shallow(nextProps, this.props);
  }

  componentDidUpdate() {
    if (!this.props.closed) {
      this.showModal();
    } else {
      this.hideModal();
    }
  }

  showModal() {
    this.setState({
      isModalVisible: true
    });
  }

  hideModal() {
    this.setState({
      isModalVisible: false,
      isErrorDetailsVisible: false
    });
  }

  onKeyUp(e) {
    if (e.keyCode === 13) this.onConfirmClick(e);else e.preventDefault();
  }

  onConfirmClick(e) {
    e.preventDefault();

    if (this.props.propose) {
      const propose_options = {
        fee_paying_account: ChainStore.getAccount(this.props.fee_paying_account).get("id")
      };
      this.props.transaction.update_head_block().then(() => {
        WalletDb.process_transaction(this.props.transaction.propose(propose_options), null, true);
      });
    } else {
      TransactionConfirmActions.broadcast(this.props.transaction, this.props.resolve, this.props.reject);
    }
  }

  onCloseClick(e) {
    e.preventDefault();
    TransactionConfirmActions.close(this.props.reject);
  }

  onShowDetailsClick() {
    this.setState(state => {
      return {
        isErrorDetailsVisible: !state.isErrorDetailsVisible
      };
    });
  }

  onProposeClick() {
    TransactionConfirmActions.togglePropose();
  }

  onProposeAccount(fee_paying_account) {
    ChainStore.getAccount(fee_paying_account);
    TransactionConfirmActions.proposeFeePayingAccount(fee_paying_account);
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (np.broadcast && np.included && !this.props.included && !np.error) {
      notify.addNotification.defer({
        children: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Translate, {
          content: "transaction.transaction_confirmed"
        }), "\xA0\xA0", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          name: "checkmark-circle",
          title: "icons.checkmark_circle.operation_succeed",
          size: "1x",
          className: "success"
        }))), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement(Operation, {
          op: this.props.transaction.serialize().operations[0],
          block: 1,
          current: "1.2.0",
          hideFee: true,
          inverted: false,
          hideOpLabel: true,
          hideDate: true
        }))),
        level: "success",
        autoDismiss: 3
      });
    }
  }

  _showQrCode() {
    let {
      transaction
    } = this.props;
    let trStr = "";

    if (transaction.tr_buffer) {
      trStr = JSON.stringify(transaction.serialize());
      this.setState({
        showQrCode: true,
        trStr
      });
    } else {
      transaction.set_expire_seconds(60);
      transaction.finalize().then(() => {
        trStr = JSON.stringify(transaction.serialize());
        this.setState({
          showQrCode: true,
          trStr
        });
      });
    }
  }

  _hideQrCode() {
    this.props.transaction.tr_buffer = null;
    this.setState({
      showQrCode: false,
      trStr: ""
    });
  }

  render() {
    let {
      broadcast,
      broadcasting
    } = this.props;
    let {
      isErrorDetailsVisible,
      showQrCode,
      trStr
    } = this.state;

    if (!this.props.transaction || this.props.closed) {
      return null;
    }

    let button_group,
        footer,
        header,
        error_code,
        error_data,
        error_message,
        confirmButtonClass = "button";
    if (this.props.propose && !this.props.fee_paying_account) confirmButtonClass += " disabled";

    if (this.props.error || this.props.included) {
      header = this.props.error ? counterpart.translate("transaction.broadcast_fail", {
        message: ""
      }) : counterpart.translate("transaction.transaction_confirmed");
      ({
        error: error_message,
        error_code,
        error_data
      } = this.props);

      if (error_code) {
        error_message = error_code + " - " + error_message;
      }

      if (error_data instanceof Object) {
        error_data = JSON.stringify(error_data, null, 4);
      }

      error_data = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("pre", null, error_data));

      if (error_data) {
        error_message = /*#__PURE__*/React.createElement("div", null, error_message, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement(Translate, {
          onClick: this.onShowDetailsClick,
          content: isErrorDetailsVisible ? "transaction.hide" : "transaction.show_more"
        })));
      }

      footer = [/*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this.onCloseClick
      }, counterpart.translate("transfer.close"))];
    } else if (broadcast) {
      header = `${counterpart.translate("transaction.broadcast_success")}. ${counterpart.translate("transaction.waiting")}`;
      footer = [/*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this.onCloseClick
      }, counterpart.translate("transfer.close"))];
    } else if (broadcasting) {
      header = /*#__PURE__*/React.createElement("div", null, counterpart.translate("transaction.broadcasting"), /*#__PURE__*/React.createElement(AIcon, {
        type: "loading"
      }));
      footer = [];
    } else {
      header = counterpart.translate("transaction.confirm");
      footer = [/*#__PURE__*/React.createElement("div", {
        style: {
          float: "left",
          cursor: "pointer",
          marginTop: "4px"
        },
        key: "scan-qr",
        onClick: this._showQrCode.bind(this)
      }, /*#__PURE__*/React.createElement(Translate, {
        style: {
          marginTop: "3px",
          marginLeft: "5px"
        },
        content: "transaction.view_qr"
      }), /*#__PURE__*/React.createElement(Icon, {
        name: "qr-scan",
        size: "1_5x"
      })), /*#__PURE__*/React.createElement(Button, {
        key: "confirm",
        type: "primary",
        onClick: this.onConfirmClick
      }, this.props.propose ? counterpart.translate("propose") : counterpart.translate("transfer.confirm")), /*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this.onCloseClick
      }, counterpart.translate("account.perm.cancel"))];
    }

    return /*#__PURE__*/React.createElement("div", {
      ref: "transactionConfirm",
      onKeyUp: this.onKeyUp
    }, /*#__PURE__*/React.createElement(Modal, {
      wrapClassName: "modal--transaction-confirm",
      title: header,
      visible: !this.props.closed,
      id: "transaction_confirm_modal",
      ref: "modal",
      footer: footer,
      overlay: true,
      onCancel: this.onCloseClick,
      overlayClose: !broadcasting,
      noCloseBtn: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block vertical no-padding no-margin"
    }, this.props.error ? /*#__PURE__*/React.createElement(Alert, {
      type: "error",
      message: error_message
    }) : null, this.props.included ? /*#__PURE__*/React.createElement(Alert, {
      type: "success",
      message: counterpart.translate("transaction.transaction_confirmed"),
      description: `#${this.props.trx_id}@${this.props.trx_block_num}`
    }) : null, isErrorDetailsVisible ? /*#__PURE__*/React.createElement(Alert, {
      type: "error",
      style: {
        fontSize: "0.7rem"
      },
      message: error_data
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "shrink",
      style: {
        maxHeight: "60vh",
        overflowY: "auto",
        overflowX: "hidden"
      }
    }, /*#__PURE__*/React.createElement(Transaction, {
      key: Date.now(),
      trx: this.props.transaction.serialize(),
      index: 0,
      no_links: true
    }), trStr ? /*#__PURE__*/React.createElement(Modal, {
      visible: showQrCode,
      onCancel: this._hideQrCode.bind(this),
      footer: /*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this._hideQrCode.bind(this)
      }, counterpart.translate("cancel"))
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        margin: "1.5rem 0"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "h4",
      content: "transaction.title_qrcode"
    })), /*#__PURE__*/React.createElement("div", {
      className: "full-width"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        background: "#fff",
        padding: ".75rem",
        display: "inline-block"
      }
    }, /*#__PURE__*/React.createElement(QRCode, {
      size: 256,
      value: trStr
    }))))) : null), this.props.propose ? /*#__PURE__*/React.createElement("div", {
      className: "full-width-content form-group"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Translate, {
      content: "account.propose_from"
    })), /*#__PURE__*/React.createElement(AccountSelect, {
      className: "full-width",
      account_names: AccountStore.getMyAccounts(),
      onChange: this.onProposeAccount.bind(this)
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink",
      style: {
        paddingTop: "1rem"
      }
    }, !this.props.transaction.has_proposed_operation() && !(broadcast || broadcasting || this.props.error) ? /*#__PURE__*/React.createElement("div", {
      className: "align-right grid-block"
    }, /*#__PURE__*/React.createElement("label", {
      style: {
        paddingRight: "0.5rem"
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "propose"
    }), ":"), /*#__PURE__*/React.createElement(Switch, {
      checked: this.props.propose,
      onChange: this.onProposeClick.bind(this)
    })) : null))));
  }

}

TransactionConfirm = connect(TransactionConfirm, {
  listenTo() {
    return [TransactionConfirmStore];
  },

  getProps() {
    return TransactionConfirmStore.getState();
  }

});
export default TransactionConfirm;